import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import IconButton from './IconButton';

export const IconButtonBridge = react2angular(IconButton, [
  'testId',
  'iconClass',
  'iconWeight',
  'title',
  'disabled',
  'id',
  'classNames',
  'pulse',
  'border',
  'onClick'
]);
